module.exports = __webpack_public_path__ + "img/jf_home_07.5c1fcc74.jpg";